const API_URL = process.env.REACT_APP_API_URL
const ENV = process.env.NODE_ENV

const config = { API_URL, ENV }

export default config
